// extracted by mini-css-extract-plugin
export var additionalLineHeight = "styles-module--additionalLineHeight--1RQF7";
export var careHomesInfoCard = "styles-module--careHomesInfoCard--2-Din";
export var container = "styles-module--container--t5IyC";
export var imgContainer = "styles-module--imgContainer--2i_9F";